import CreateOfferVouchers from "../../features/dashboard/offerVouchers/CreateOfferVouchers";

function OfferVouchersDB() {
    return <CreateOfferVouchers />
}

export default OfferVouchersDB